/**
 * ExerciseLoggerModal - Extracted from App.js Phase 4
 * Log exercise activity with AI calorie burn calculation
 */
import React from 'react';

const ExerciseLoggerModal = ({
  isOpen,
  onClose,
  exerciseForm,
  setExerciseForm,
  logExercise,
  analyzing
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="heading-3">Log Exercise Activity</h2>
        <p className="modal-description">Track your workout and calculate calories burned</p>
        
        <div className="meal-plan-form">
          <div className="form-group">
            <label>Activity Type</label>
            <select 
              value={exerciseForm.activity}
              onChange={(e) => setExerciseForm({...exerciseForm, activity: e.target.value})}
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--input-bg)', color: 'var(--text-primary)' }}
            >
              <option value="">Select Activity</option>
              <optgroup label="Cardio">
                <option value="Running">Running</option>
                <option value="Jogging">Jogging</option>
                <option value="Walking">Walking</option>
                <option value="Cycling">Cycling</option>
                <option value="Swimming">Swimming</option>
                <option value="Rowing">Rowing</option>
                <option value="Jump Rope">Jump Rope</option>
                <option value="Elliptical">Elliptical</option>
                <option value="Stair Climbing">Stair Climbing</option>
              </optgroup>
              <optgroup label="Strength Training">
                <option value="Weightlifting">Weightlifting</option>
                <option value="CrossFit">CrossFit</option>
                <option value="Bodyweight Training">Bodyweight Training</option>
                <option value="Powerlifting">Powerlifting</option>
                <option value="Circuit Training">Circuit Training</option>
              </optgroup>
              <optgroup label="Sports">
                <option value="Basketball">Basketball</option>
                <option value="Soccer">Soccer</option>
                <option value="Tennis">Tennis</option>
                <option value="Volleyball">Volleyball</option>
                <option value="Baseball">Baseball</option>
                <option value="Golf">Golf</option>
                <option value="Hockey">Hockey</option>
                <option value="Badminton">Badminton</option>
              </optgroup>
              <optgroup label="Winter Sports">
                <option value="Skiing (Downhill)">Skiing (Downhill)</option>
                <option value="Skiing (Cross-Country)">Skiing (Cross-Country)</option>
                <option value="Snowboarding">Snowboarding</option>
                <option value="Ice Skating">Ice Skating</option>
                <option value="Snowshoeing">Snowshoeing</option>
                <option value="Ice Hockey">Ice Hockey</option>
              </optgroup>
              <optgroup label="Summer/Outdoor">
                <option value="Hiking">Hiking</option>
                <option value="Rock Climbing">Rock Climbing</option>
                <option value="Kayaking">Kayaking</option>
                <option value="Surfing">Surfing</option>
                <option value="Paddleboarding">Paddleboarding</option>
                <option value="Beach Volleyball">Beach Volleyball</option>
              </optgroup>
              <optgroup label="Fitness Classes">
                <option value="Yoga">Yoga</option>
                <option value="Pilates">Pilates</option>
                <option value="Zumba">Zumba</option>
                <option value="Spin Class">Spin Class</option>
                <option value="Boxing">Boxing</option>
                <option value="Kickboxing">Kickboxing</option>
                <option value="HIIT">HIIT</option>
                <option value="Aerobics">Aerobics</option>
              </optgroup>
              <optgroup label="Other">
                <option value="Dancing">Dancing</option>
                <option value="Martial Arts">Martial Arts</option>
                <option value="Skateboarding">Skateboarding</option>
                <option value="Rollerblading">Rollerblading</option>
              </optgroup>
            </select>
          </div>

          <div className="form-group" style={{ marginTop: '16px' }}>
            <label>Duration (minutes)</label>
            <input type="text" inputMode="decimal" placeholder="e.g., 30"
              value={exerciseForm.duration_minutes}
              onChange={(e) => setExerciseForm({...exerciseForm, duration_minutes: e.target.value})}
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--input-bg)', color: 'var(--text-primary)' }} />
          </div>

          <div className="form-group" style={{ marginTop: '16px' }}>
            <label>Intensity Level</label>
            <select value={exerciseForm.intensity}
              onChange={(e) => setExerciseForm({...exerciseForm, intensity: e.target.value})}
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--input-bg)', color: 'var(--text-primary)' }}>
              <option value="Light">Light (Easy pace, can talk easily)</option>
              <option value="Moderate">Moderate (Comfortable pace, can talk with effort)</option>
              <option value="Vigorous">Vigorous (Hard pace, difficult to talk)</option>
            </select>
          </div>

          <div style={{ marginTop: '16px', padding: '12px', background: 'rgba(33, 150, 243, 0.1)', borderRadius: '8px', fontSize: '13px', lineHeight: '1.5' }}>
            <p style={{ margin: 0, color: 'var(--text-secondary)' }}>
              AI will calculate calories burned based on your profile (weight, age, gender, body type) and the activity details you provide.
            </p>
          </div>

          <button className="btn-primary full-width" onClick={logExercise} disabled={analyzing} style={{ marginTop: '16px' }}>
            {analyzing ? 'Calculating Calories...' : 'Log Exercise'}
          </button>

          <button className="btn-secondary full-width" onClick={() => {
            onClose();
            setExerciseForm({ activity: '', duration_minutes: '', intensity: 'Moderate' });
          }} style={{ marginTop: '12px' }}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ExerciseLoggerModal;
